import action from './actions';
import type { IModuleState } from './interface';
import { getStore as getState, setupStore as initialize, useStore } from './store';

function ModuleState(): IModuleState {
    initialize();

    return {
        useState: useStore,
        getState,
        action: action(),
    };
}

export default ModuleState;
